import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#0a0a09]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <motion.a
          href="#contact"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="group block font-serif-display font-light text-6xl md:text-8xl lg:text-9xl tracking-tight leading-none mb-16"
        >
          Let&apos;s <span className="italic gold-text group-hover:text-[#f3e5ab] transition-colors duration-500">Talk</span>
        </motion.a>

        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 pt-10 border-t border-white/10">
          <div className="flex items-center gap-3">
            <span className="w-2 h-2 rotate-45 bg-[#d4af37]" />
            <span className="font-serif-display text-2xl">
              Atelier <span className="gold-text italic">Noir</span>
            </span>
          </div>

          <div className="text-white/40 text-sm max-w-md md:text-right leading-relaxed space-y-2">
            <p data-testid="footer-disclaimer">Demo projects are showcased for portfolio purposes.</p>
            <p>© {new Date().getFullYear()} Atelier Noir. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
